<template>
	<div class="item-edit" style="animation-delay: 2s">
		<div class="mb-2">Bitte gib hier den Code ein:</div>
		<b-input
			v-model="code"
			ref="mobilePhoneCodeInput"
			class="w-auto"
			@keyup.enter="confirm"
		/>
		<div class="mt-4">
			<Button
				text="Code bestätigen"
				icon="checkmark"
				:loading="saving"
				:disabled="!codeValid || saving"
				@click="confirm"
			/>
		</div>
		<div class="mt-4">
			<div>Mobilnummer falsch?</div>
			<div>
				<a href="#" @click.prevent="$emit('change')">Hier ändern</a>
			</div>
		</div>
		<div class="mt-4">
			<div>Keine SMS bekommen?</div>
			<div>
				<div v-if="sentAgain" class="success">Erfolgreich versendet</div>
				<a v-else-if="!saving" href="#" @click.prevent="resend">Hier nochmals senden</a>
			</div>
		</div>
	</div>
</template>

<script>
import Button from "@/vue/common/Button.vue"
import {isEmptyOrNull} from "@/helper/String";
import Legitimate from "@/api/customer/legitimation/Legitimate";
import {MOBILE_PHONE} from "@/helper/customer/legitimation/Type";
import * as Toast from "@/helper/layout/Toast";
import * as Log from "@/helper/Log";
import flatten from "@/helper/error/Errors";

export default {

	props: {
		user: {
			type: Object,
			required: true
		},
		jobProfile: {
			type: Object,
			required: true
		},
	},

	components: {
		Button,
	},

	mounted ()
	{
		this.$refs.mobilePhoneCodeInput.focus();
	},

	data ()
	{
		return {
			code: '',
			sentAgain: false,
			saving: false
		};
	},

	computed: {
		codeValid ()
		{
			return !isEmptyOrNull(this.code);
		},
	},

	methods: {
		async confirm ()
		{
			if (!this.codeValid)
			{
				return;
			}

			this.saving = true;

			try
			{
				const response = await new Legitimate()
					.setType(MOBILE_PHONE)
					.setValue(
						_.trim(this.code)
					)
					.setPublishJobProfileIfPossible(this.jobProfile.id)
					.call();

				this.$emit('finish', {
					publishedJobProfile: response.data?.publishedJobProfile || false
				});
			}
			catch (e)
			{
				Log.error(e);

				Toast.error(this, flatten(e.errors));
			}

			this.saving = false;
		},
		resend ()
		{
			this.$emit('resend');

			this.sentAgain = true;

			window.setTimeout(() => this.sentAgain = false, 3000);
		}
	}
}
</script>
